// Admin kann Teilnehmern eine Wichtigkeit (0–3 Sterne) zuweisen.
// Lokal pro Browser, niemals an den Server — der Server kennt keine
// Identitäten. Wird in's Best-Slot-Ranking als Gewicht eingerechnet
// (0 → 1, 1 → 1, 2 → 2, 3 → 3 — der Floor 1 stellt sicher, dass auch
// „nicht bewertete" Voter zählen).
//
// Key: slot:voter-importance:<surveyId> → { [pseudonym]: 0..3 }

export type ImportanceMap = Record<string, number>;

const KEY = (surveyId: string) => `slot:voter-importance:${surveyId}`;

export function loadImportance(surveyId: string): ImportanceMap {
  try {
    const raw = localStorage.getItem(KEY(surveyId));
    if (!raw) return {};
    const obj = JSON.parse(raw) as unknown;
    if (typeof obj !== 'object' || obj === null) return {};
    const out: ImportanceMap = {};
    for (const [k, v] of Object.entries(obj as Record<string, unknown>)) {
      if (typeof v === 'number' && v >= 0 && v <= 3) out[k] = Math.round(v);
    }
    return out;
  } catch {
    return {};
  }
}

export function saveImportance(surveyId: string, map: ImportanceMap): void {
  try { localStorage.setItem(KEY(surveyId), JSON.stringify(map)); }
  catch { /* Quota? Ignorieren — UI degradiert auf ungewichtetes Ranking. */ }
}

/** Gewicht eines Voters für die Score-Berechnung. Floor 1, damit ungerated
 *  Voter nicht aus dem Ranking fallen. */
export function weightFor(map: ImportanceMap, pseudonym: string): number {
  const lvl = map[pseudonym] ?? 0;
  return Math.max(1, lvl);
}
